












import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { AccountAsset } from '@/modules/AccountAsset/interfaces/account-asset'
import S3Handler from '@/mixins/s3'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'

@Component({
  components: {
    AppAttachmentsCard
  }
})
export default class AccountAssetDetailContact extends mixins(S3Handler) {
  @Prop({ type: Object as () => AccountAsset }) readonly accountAsset!: AccountAsset

  get attachmentList () {
    return this.accountAsset.files || []
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }
}
